// extracted by mini-css-extract-plugin
export default {"CardContainer":"SmallCard_CardContainer__e0Bfm","InfoCardContainer":"SmallCard_InfoCardContainer__SKvfj","Title":"SmallCard_Title__PyE5M"};